<template>
  <a-layout-header :class="[fixHeader && 'ant-header-fixedHeader', layout === 'side' ? (isMobile || !sidebarOpened ? 'ant-header-side-closed' : 'ant-header-side-opened') : null, theme, 'global-header' ]">
    <div :class="['global-header-wide', layout]">
      <router-link v-if="isMobile || layout === 'head'" to="/" :class="['logo', isMobile ? null : 'pc', theme]">
        <!-- <img width="32" src="static/img/logo.png"  alt=""/> -->
        <h1 v-if="!isMobile">{{systemName}}</h1>
      </router-link>
      <a-divider v-if="isMobile" type="vertical" />
      <a-icon v-if="layout === 'side'" class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggleCollapse"/>
      <div v-if="layout === 'head'" class="global-header-menu">
        <i-menu style="height: 64px; line-height: 64px;" class="system-top-menu" :theme="theme" mode="horizontal" :menuData="menuData" @select="onSelect"/>
      </div>
      <div :class="['global-header-right', theme]">
          <!-- 语言选择 -->
          <div class="header-item language-selector">
            <a-select
              :value="$i18n.locale"
              @change="handleLanguageChange"
              :dropdownMatchSelectWidth="false"
              size="small"
              class="lang-select"
            >
              <a-select-option value="zh-CN">简体中文</a-select-option>
              <a-select-option value="en-US">English</a-select-option>
              <a-select-option value="es-ES">Español</a-select-option>
              <a-select-option value="fr-FR">Français</a-select-option>
              <a-select-option value="de-DE">Deutsch</a-select-option>
              <a-select-option value="th-TH">ไทย</a-select-option>
              <a-select-option value="vi-VN">Tiếng Việt</a-select-option>
              <a-select-option value="ms-MY">Bahasa Melayu</a-select-option>
              <a-select-option value="id-ID">Bahasa Indonesia</a-select-option>
            </a-select>
          </div>

          <!-- 时区选择 -->
          <div class="header-item timezone-selector">
            <a-select
              :value="timezone"
              @change="handleTimezoneChange"
              :dropdownMatchSelectWidth="false"
              size="small"
              class="timezone-select"
              show-search
              :filter-option="filterTimezone"
            >
              <a-select-option
                v-for="tz in timezones"
                :key="tz.value"
                :value="tz.value"
              >
                {{ tz.label }}
              </a-select-option>
            </a-select>
          </div>

          <header-avatar class="header-item"/>
      </div>
    </div>
  </a-layout-header>
</template>

<script>
import HeaderAvatar from './HeaderAvatar'
import IMenu from '@/components/menu/menu'
import { mapState, mapMutations } from 'vuex'
import timezones from '@/utils/timezones'
import { detectLocalTimezone } from '@/utils/timezoneUtil'

export default {
  name: 'GlobalHeader',
  components: {IMenu, HeaderAvatar},
  props: ['collapsed', 'menuData'],
  data () {
    return {
      timezones: timezones,
      timezone: localStorage.getItem('timezone') || detectLocalTimezone()
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.setting.isMobile,
      layout: state => state.setting.layout,
      systemName: state => state.setting.systemName,
      sidebarOpened: state => state.setting.sidebar.opened,
      fixHeader: state => state.setting.fixHeader
    }),
    theme () {
      if (this.layout === 'side') {
        return this.$store.state.setting.theme
      } else {
        return this.$store.state.setting.theme
      }
    }
  },
  methods: {
    ...mapMutations({
      setTimezone: 'setting/setTimezone'
    }),
    toggleCollapse () {
      this.$emit('toggleCollapse')
    },
    onSelect (obj) {
      this.$emit('menuSelect', obj)
    },
    handleLanguageChange (value) {
      // 切换语言
      this.$i18n.locale = value
      localStorage.setItem('lang', value)

      // 更新 moment locale
      if (value === 'zh-CN') {
        require('moment/locale/zh-cn')
        window.moment && window.moment.locale('zh-cn')
      } else if (value === 'en-US') {
        window.moment && window.moment.locale('en-gb')
      }

      this.$message.success(this.$t('common.languageChanged') || 'Language changed successfully')
    },
    handleTimezoneChange (value) {
      // 切换时区
      this.timezone = value
      localStorage.setItem('timezone', value)

      // 更新 Vuex store
      this.setTimezone(value)

      // 触发全局事件，通知其他组件时区已更改
      this.$root.$emit('timezone-change', value)

      this.$message.success(this.$t('common.timezoneChanged') || 'Timezone changed successfully')
    },
    filterTimezone (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  },
  created () {
    // 初始化时区设置：优先使用用户手动选择过的时区，否则自动切换为用户当地时区
    const savedTimezone = localStorage.getItem('timezone')
    if (savedTimezone) {
      this.timezone = savedTimezone
    } else {
      this.timezone = detectLocalTimezone()
      localStorage.setItem('timezone', this.timezone)
    }
    this.setTimezone(this.timezone)
  }
}
</script>

<style lang="less" scoped>
  .trigger {
    font-size: 20px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color .3s;
  }
  .header-item{
    padding: 0 19px;
    display: inline-block;
    height: 100%;
    cursor: pointer;
    vertical-align: middle;
    i{
      font-size: 16px;
      color: rgba(0,0,0,.65);
    }
  }
  .global-header{
    padding: 0 12px 0 0;
    -webkit-box-shadow: 0 1px 4px rgba(0,21,41,.08);
    box-shadow: 0 1px 4px rgba(0,21,41,.08);
    position: relative;
    /* 兜底防护：即使意外换行也不允许溢出头部遮挡下方内容 */
    overflow: hidden;
    &.light{
      background: #fff;
    }
    &.violet{
      background: linear-gradient(90deg, #36245C, #9068FF);;
    }
    &.dark{
      background: #393e46;
    }
    .global-header-wide{
      &.head{
        padding: 0 24px;
      }
      &.side{
      }
      &.violet{
        color:#fff
      }
      &.dark{
        color:#fff
      }
      .logo {
        height: 64px;
        line-height: 58px;
        vertical-align: top;
        display: inline-block;
        padding: 0 12px 0 24px;
        cursor: pointer;
        font-size: 20px;
        &.pc{
          padding: 0 12px 0 0;
        }
        img {
          display: inline-block;
          vertical-align: middle;
        }
        h1{
          display: inline-block;
          font-size: 16px;
        }
        &.dark h1{
          color: #fff;
        }
      }
      .global-header-menu{
        display: inline-block;
      }
      .global-header-right{
        float: right;
        &.dark{
          color: #fff;
          i{
            color: #fff;
          }
        }
        &.violet{
          color: #fff;
          i{
            color: #fff;
          }
        }
      }
    }
  }
  .ant-header-fixedHeader {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 15;
    width: 100%;
    transition: width .2s;

    &.ant-header-side-opened {
      width: 100%;
      padding-left: 254px;
    }

    &.ant-header-side-closed {
      width: 100%;
      padding-left: 80px;
    }
  }
  /deep/.ant-menu-violet .ant-menu-item{
    color: #fff;
  }
   /deep/.ant-menu-violet .ant-menu-item-group-title{
    color: #fff;
  }
   /deep/ .ant-menu-violet .ant-menu-item > a{
    color: #fff;
  }
  .dark .anticon-menu-fold{color: #fff;}
  .violet .anticon-menu-fold{color: #fff;}

  /* 窄屏渐进隐藏：宽度不足时先隐藏时区选择，仍不足再隐藏语言选择，避免头部换行溢出遮挡内容 */
  @media screen and (max-width: 1100px) {
    .timezone-selector {
      display: none;
    }
  }
  @media screen and (max-width: 800px) {
    .language-selector {
      display: none;
    }
  }

  /* 语言和时区选择器样式 */
  .language-selector, .timezone-selector {
    display: inline-block;
    padding: 0 8px;

    /deep/ .ant-select {
      min-width: 120px;

      .ant-select-selection {
        background: transparent;
        border: none;
        box-shadow: none;
      }
    }

    &.language-selector {
      /deep/ .ant-select {
        min-width: 100px;
      }
    }

    &.timezone-selector {
      /deep/ .ant-select {
        min-width: 280px;

        .ant-select-selection__rendered {
          margin-left: 8px;
          margin-right: 24px;
        }
      }
    }
  }

  /* 主题适配 */
  .global-header.light {
    .language-selector, .timezone-selector {
      /deep/ .ant-select {
        .ant-select-selection {
          color: rgba(0, 0, 0, 0.65);
        }

        .ant-select-arrow {
          color: rgba(0, 0, 0, 0.65);
        }

        &:hover .ant-select-selection {
          color: #1890ff;
        }
      }
    }
  }

  .global-header.dark,
  .global-header.violet {
    .language-selector, .timezone-selector {
      /deep/ .ant-select {
        .ant-select-selection {
          color: #fff;
        }

        .ant-select-arrow {
          color: #fff;
        }

        &:hover .ant-select-selection {
          color: #40a9ff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/common/GlobalHeader.vue